import { render, staticRenderFns } from "./TextTruncate.vue?vue&type=template&id=9e0094be"
import script from "./TextTruncate.vue?vue&type=script&lang=js"
export * from "./TextTruncate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports